import axios from "@/plugins/axios";


export default {
    findById(strategyId) {
        return axios.httpApi.get("/strategy/" + strategyId);
    },

    async list(creditor, active = false, selectedPublic, pagination = {}, all = false, approachTypes = [], onlyFired = false, workspace = "MANUAL") {
        let params = {};

        creditor = creditor ? creditor : null;
        if (creditor) {
            if (creditor.length)
                params.creditor_ids = creditor.map((id) => id).join(",");
            else
                params.creditor = creditor
        }

        if (!all) params.active = active;
        if (selectedPublic) params.public = selectedPublic;
        if (onlyFired) params.only_fired = onlyFired;
        if (approachTypes.length)
            params.approach_types = approachTypes.map((sp) => sp).join(",");
        if (workspace) params.workspace = workspace;

        params.page = pagination.page;
        params.limit =
            pagination.limit == -1 ? 9999 : pagination.limit;
        if (pagination.order)
            params.order =
            (pagination.descending ? "-" : "") + pagination.order;

        return await axios.httpApi.get("/strategy", { params });
    },

    save(data) {
        data = JSON.parse(JSON.stringify(data));

        delete data.selected;
        delete data.creditor;
        delete data.approach;
        delete data.updated_at;
        delete data.created_at;
        delete data.state
        delete data.debit_type
        delete data.segmentString
        delete data.segmentString2
        delete data.segmentString3
        delete data.segmentString4
        delete data.typeApproach

        data.order = 1
        if (data.id) {
            return axios.httpApi.patch("/strategy/" + data.id, data);
        }
        return axios.httpApi.post("/strategy", data);
    },

    delete(strategyId) {
        return axios.httpApi.delete("/strategy/" + strategyId);
    },

    async listAll(creditor, active = false, selectedPublic, all = false, approachTypes, onlyFired, workspace) {
        let _pagination = {
            limit: 1000,
            page: 1,
        };
        let result = [];
        let loop = true

        do {
            let res = await this.list(
                creditor,
                active,
                selectedPublic,
                _pagination,
                all,
                approachTypes,
                onlyFired,
                workspace
            );
            result = result.concat(res.objects);
            _pagination.page++;
            if (res.objects.length < _pagination.limit) {
                loop = false
                return {
                    objects: result,
                    totalItems: _pagination.totalItems,
                };
            }
        } while (loop);
    },
};